var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2698_902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.7933,
    height: 27.7933,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2698_902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0841 23.1611C17.7737 23.1611 17.5031 23.0457 17.2723 22.8148C17.0414 22.584 16.926 22.3134 16.926 22.003V16.9255C16.926 16.6152 17.0414 16.3446 17.2723 16.1137C17.5031 15.8829 17.7737 15.7675 18.0841 15.7675H23.1616C23.4719 15.7675 23.7425 15.8829 23.9734 16.1137C24.2042 16.3446 24.3196 16.6152 24.3196 16.9255V22.003C24.3196 22.3134 24.2042 22.584 23.9734 22.8148C23.7425 23.0457 23.4719 23.1611 23.1616 23.1611H18.0841ZM3.47461 20.0433V18.8853H13.0063V20.0433H3.47461ZM18.0841 12.0258C17.7737 12.0258 17.5031 11.9104 17.2723 11.6795C17.0414 11.4487 16.926 11.1781 16.926 10.8678V5.79026C16.926 5.4799 17.0414 5.2093 17.2723 4.97846C17.5031 4.74762 17.7737 4.6322 18.0841 4.6322H23.1616C23.4719 4.6322 23.7425 4.74762 23.9734 4.97846C24.2042 5.2093 24.3196 5.4799 24.3196 5.79026V10.8678C24.3196 11.1781 24.2042 11.4487 23.9734 11.6795C23.7425 11.9104 23.4719 12.0258 23.1616 12.0258H18.0841ZM3.47461 8.90803V7.74998H13.0063V8.90803H3.47461Z",
    fill: "#ADC9FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventList);
export default __webpack_public_path__ + "static/media/event_list.b8200e4ea17eabf2e43630cd0e5e6012.svg";
export { ForwardRef as ReactComponent };